// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import './style/index.css';
import App from './App'
import router from './router'
import VueClipBoard from 'vue-clipboard2'

import ElementUI from 'element-ui' //引入element-ui库
import 'element-ui/lib/theme-chalk/index.css';
import './assets/styles/reset.css'
import './assets/index.css';

import * as echarts from 'echarts' //引入echarts
Vue.prototype.$echarts = echarts

const bus = new Vue()
// 把bus挂载到了Vue的原型上, 保证所有的组件都能通过 this.$bus访问到事件总线
Vue.use(ElementUI)  //全局注册element-ui

/* eslint-disable no-new */
Vue.use(VueClipBoard)

new Vue({
  el: '#app',
  router,
  components: {App},
  render: h => h(App),
  beforeCreate() {
    Vue.prototype.$bus = this;
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js